import { User, UserRole } from "./User.types";

export const generateEmptyUser = (override: Partial<User>): User => ({
  homeTrack: "",
  id: undefined!,
  keycloakId: "",
  raceTag: "",
  username: "",
  friends: [],
  role: UserRole.USER,
  email: "",
  ...override,
});
